<template>
  <fieldset class="prompt">
    <h2 class="prompt__heading">{{ heading }}</h2>
    <p class="prompt__body" v-if="body">{{ body }}</p>
    <HUITextInput
      class="prompt__input"
      name="input"
      v-model="input"
      required
      :placeholder="placeholder"
    />
  </fieldset>
</template>

<script>
import { HUITextInput } from '@/halifax-ui'

export default {
  components: {
    HUITextInput
  },
  props: {
    heading: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    body: String
  },
  data() {
    return {
      input: ''
    }
  }
}
</script>

<style lang="scss">
@import '~@/scss/variables';
@import '~@/halifax-ui/src/scss/framework';

.prompt {
  background-color: $background-color;
  padding: 20px 25px;

  &__heading {
    text-align: center;
    margin-bottom: 5px;
    line-height: 1.15;
  }
  &__body {
    text-align: center;
    font-size: 1.4rem;
  }
  &__input {
    margin-top: 20px;
    margin-left: -5px;
    margin-right: -5px;
  }
}
</style>
